import { render } from "./DonorService.vue?vue&type=template&id=75259d2c"
import script from "./DonorService.vue?vue&type=script&lang=js"
export * from "./DonorService.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__